
<ng-container *ngIf="showDeviceRegistrationModal">
	<app-mobile-kamona-message-widget
		[modalType]="ModalType.CUSTOM">
		<ng-container>
			<ng-container *ngTemplateOutlet="deviceRegistrationTemplate"></ng-container>
		</ng-container>
	</app-mobile-kamona-message-widget>
</ng-container>

<ng-container *ngIf="isUserSuspended">
	<app-mobile-kamona-message-widget
		[title]="suspendedTitle"
		[iconType]="iconType"
		[btnText]="btnText"
		[btnType]="btnType"
		(emitCancel)="closeUserSuspensionModal()"
		[suspensionReleaseTimeEpoch]="suspensionReleaseTimeEpoch"
		[description]="suspendedDescription">
	</app-mobile-kamona-message-widget>
</ng-container>



<div class="min-h-screen bg-[#F5F5F5] flex flex-col pb-[40px] px-[20px] justify-between">
	<div>
		<ng-container *ngTemplateOutlet="header"></ng-container>
	</div>
	<div class="grow"></div>
	<div>
		<ng-container *ngTemplateOutlet="footer"></ng-container>
	</div>
</div>


<ng-template #header>
	<ng-container *ngIf="currentForm === SignInForm.PASSWORD else defaultHeaderTemplate">
		<div class="flex items-center justify-between pt-[30px]">
			<div>
				<svg (click)="goBack()" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M16.1705 19.8658C15.7312 20.3051 15.0188 20.3051 14.5795 19.8658L7.8295 13.1158C7.39017 12.6765 7.39017 11.9642 7.8295 11.5248L14.5795 4.77482C15.0188 4.33548 15.7312 4.33548 16.1705 4.77482C16.6098 5.21416 16.6098 5.92647 16.1705 6.36581L10.216 12.3203L16.1705 18.2748C16.6098 18.7142 16.6098 19.4265 16.1705 19.8658Z" fill="#0361F0"/>
				</svg>
			</div>
			<div *ngIf="maskPhoneNumber && usernameType === UserNameType.PHONENUMBER"
				 class="flex gap-[4px] items-center bg-[#DBE7FD] rounded-[8px] py-[4px] px-[8px]">
				<div>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12.4912 9.68967C11.8413 9.69093 11.1954 9.58819 10.5779 9.38538C10.2892 9.28456 9.96842 9.35248 9.74537 9.56167L8.53387 10.4756C7.23279 9.8224 6.1771 8.76693 5.52363 7.46595L6.41344 6.28364C6.6381 6.05882 6.71845 5.72743 6.62173 5.42469C6.41816 4.8064 6.31487 4.15953 6.31576 3.50861C6.31576 3.04353 5.93873 2.6665 5.47365 2.6665H3.50873C3.04365 2.6665 2.66663 3.04353 2.66663 3.50861C2.67281 8.93201 7.06779 13.327 12.4912 13.3332C12.9563 13.3332 13.3333 12.9561 13.3333 12.4911V10.5318C13.3333 10.0667 12.9563 9.68967 12.4912 9.68967Z" fill="#0357EE"/>
					</svg>
				</div>
				<div class=" text-[#0357EE] text-[14px] leading-[19.6px] font-bold">
					{{maskPhoneNumber}}
				</div>
			</div>
		</div>
	</ng-container>
</ng-template>


<ng-template #defaultHeaderTemplate>
	<div class="pt-[60px]">
		<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_31528_7710)">
				<g clip-path="url(#clip1_31528_7710)">
					<rect x="11.2467" y="11.9492" width="27.2008" height="26.2117" fill="white"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M24.5553 49.456H24.732C36.1556 49.456 43.8106 47.063 45.4005 45.5563C47.0787 44.0495 49.2869 36.2205 49.2869 24.728C49.2869 13.2355 47.0787 5.40648 45.4005 3.89976C43.8106 2.42258 36.1556 0.0295436 24.732 0H24.5553C13.1611 0.0295436 5.47666 2.42258 3.88678 3.89976C2.20856 5.40648 0.000387192 13.2355 0.000387192 24.728C0.000387192 36.25 2.20856 44.0495 3.88678 45.5563C5.47666 47.0335 13.1317 49.4265 24.5553 49.456ZM35.0655 14.6535L36.0076 26.2051L36.6554 34.8318H33.1812C31.7091 34.8318 31.0908 34.1819 30.973 32.5865L30.4725 21.9213H30.4136C30.0014 23.4871 26.7627 31.3161 26.7627 31.3161H22.4936C22.4936 31.3161 19.255 23.3689 19.0194 22.5417L18.8428 21.9213H18.7839C18.8722 23.2803 18.2834 32.5865 18.2834 32.5865C18.1656 34.1819 17.5767 34.8318 16.0752 34.8318H12.601L13.3959 24.6688L14.3381 14.6535H20.0499L24.6135 24.7575H24.6723C25.0551 23.5462 29.3831 14.6535 29.3831 14.6535H35.0655Z" fill="#0361F0"/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_31528_7710">
					<rect width="49.456" height="49.456" fill="white"/>
				</clipPath>
				<clipPath id="clip1_31528_7710">
					<rect width="49.456" height="49.456" fill="white"/>
				</clipPath>
			</defs>
		</svg>
	</div>
</ng-template>

<ng-template #footer>
	<div class="flex flex-col gap-[24px]">
		<ng-container [ngSwitch]="currentForm">
			<ng-container *ngSwitchDefault>
				<ng-container *ngTemplateOutlet="usernameFormTemplate"></ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="SignInForm.PASSWORD">
				<ng-container *ngTemplateOutlet="passwordFormTemplate"></ng-container>
			</ng-container>
		</ng-container>
	</div>
</ng-template>

<ng-template #usernameFormTemplate>
	<div class="text-black text-[24px] leading-[29.76px] font-bold">
		Log in to your account
	</div>
	<div class="bg-white rounded-[12px] min-h-[215px] flex flex-col gap-[16px] py-[24px] px-[16px]">
		<div class="flex items-center justify-between">
			<div class="text-[#666666] text-[12px] leading-[17.76px] font-semibold">
				Login with
			</div>
			<div class="flex gap-[16px]">
				<div [ngClass]="phoneNumberTabClass" (click)="handleSelectedTab(0)" class="w-[99px] cursor-pointer items-center flex gap-[4px] h-[28px] rounded-[25px] py-[5.5px] pl-[12px] pr-[8px]">
					<div>
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12.4912 9.68967C11.8414 9.69093 11.1954 9.58819 10.578 9.38538C10.2893 9.28456 9.96848 9.35248 9.74543 9.56167L8.53393 10.4756C7.23285 9.8224 6.17716 8.76693 5.52369 7.46595L6.41351 6.28364C6.63816 6.05882 6.71851 5.72743 6.6218 5.42469C6.41822 4.8064 6.31493 4.15953 6.31582 3.50861C6.31582 3.04353 5.93879 2.6665 5.47372 2.6665H3.50879C3.04371 2.6665 2.66669 3.04353 2.66669 3.50861C2.67287 8.93201 7.06785 13.327 12.4912 13.3332C12.9563 13.3332 13.3334 12.9561 13.3334 12.4911V10.5318C13.3334 10.0667 12.9563 9.68967 12.4912 9.68967Z" [attr.fill]="nzSelectedIndex ? defaultSvgColor : selectedSvgColor"/>
						</svg>
					</div>
					<div [ngClass]="{'text-white':!nzSelectedIndex, 'text-[#546F9E]':nzSelectedIndex}" class="text-[12px] leading-[14.88px] font-medium">
						Phone No
					</div>
				</div>
				<div [ngClass]="usernameTabClass" (click)="handleSelectedTab(1)" class="w-[99px] cursor-pointer items-center flex gap-[4px] h-[28px] rounded-[25px] py-[5.5px] pl-[12px] pr-[8px]">
					<div>
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9.96522 2.87268C9.46624 2.30991 8.76931 2 8.00007 2C7.22673 2 6.52749 2.30804 6.03082 2.86732C5.52876 3.43277 5.28415 4.20125 5.34158 5.03107C5.45543 6.66821 6.64801 8 8.00007 8C9.35213 8 10.5427 6.66848 10.6583 5.03161C10.7165 4.20929 10.4703 3.44241 9.96522 2.87268Z" [attr.fill]="!nzSelectedIndex ? defaultSvgColor : selectedSvgColor"/>
							<path d="M12.5127 13.9999H3.48732C3.36919 14.0016 3.2522 13.9747 3.14486 13.9212C3.03753 13.8677 2.94254 13.789 2.86683 13.6908C2.70017 13.4749 2.63299 13.1802 2.68273 12.8822C2.89913 11.5816 3.5745 10.4891 4.63601 9.72221C5.57906 9.04138 6.77364 8.66667 8.00002 8.66667C9.2264 8.66667 10.421 9.04166 11.364 9.72221C12.4255 10.4889 13.1009 11.5813 13.3173 12.8819C13.3671 13.1799 13.2999 13.4747 13.1332 13.6905C13.0575 13.7888 12.9625 13.8676 12.8552 13.9211C12.7479 13.9746 12.6309 14.0016 12.5127 13.9999Z" [attr.fill]="!nzSelectedIndex ? defaultSvgColor : selectedSvgColor"/>
						</svg>
					</div>
					<div [ngClass]="{'text-white':nzSelectedIndex, 'text-[#546F9E]':!nzSelectedIndex}" class="text-[12px] leading-[14.88px] font-medium">
						Username
					</div>
				</div>
			</div>
		</div>
		<ng-container *ngIf="!nzSelectedIndex else userNameTemplate">
			<ng-container *ngTemplateOutlet="phoneNumberTemplate"></ng-container>
		</ng-container>
	</div>
	<div *ngIf="nzSelectedIndex" (click)="forgotUsername()"
		 class="text-[#0361F0] flex justify-center cursor-pointer text-[14px] leading-[17.36px] font-medium animate__animated animate__slideInRight">
		Forgot Username?
	</div>
</ng-template>

<ng-template #passwordFormTemplate>
	<ng-container [ngSwitch]="passwordType">
		<ng-container *ngSwitchDefault>
			<div class="-mx-[20px] -mb-[48px]">
			<app-mobile-kamona-passcode-widget
				[hideHeader]="true"
				[minHeightStyle]="passcodeContainerHeight"
				(emitSubmit)="handleOnSubmitPasscode($event)"
				[version]="CustomTimelineVersion.version_8">
				<ng-container>
					<div class="flex flex-col text-black text-center gap-[8px]">
						<div class="text-[24px] leading-[29.76px] font-semibold">
							Enter your passcode
						</div>
						<div class="text-[12px] leading-[17.76px] font-normal">Enter your 6 digit passcode</div>
					</div>
				</ng-container>
			</app-mobile-kamona-passcode-widget>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="PasswordType.PASSWORD">
			<div class="text-black text-[24px] leading-[29.76px] font-bold">
				Enter your Password
			</div>
			<div class="bg-white rounded-[12px] flex flex-col gap-[16px] py-[24px] px-[16px]">
				<div class="flex-col flex gap-[16px]">
					<app-web-kamona-password-widget
						[usePasswordForm]="false"
						[minHeight]="44"
						oldPasswordPlaceHolder="Enter Password"
						(emitSubmit)="setPassword($event)">
					</app-web-kamona-password-widget>
					<ng-container *ngTemplateOutlet="pwdBtn"></ng-container>
				</div>
			</div>
		</ng-container>
	</ng-container>
	<div (click)="handleForgotCredentials()" class="text-[#0361F0] flex justify-center cursor-pointer text-[14px] leading-[17.36px] font-medium">
		Forgot {{passwordType | titlecase}}?
	</div>
</ng-template>

<ng-template #phoneNumberTemplate>
	<div class="flex flex-col gap-[20px] animate__animated animate__slideInLeft">
		<app-kamona-phone-number-field
			[input]="phoneNumber">
		</app-kamona-phone-number-field>
		<ng-container *ngTemplateOutlet="phoneNumberBtn"></ng-container>
	</div>
</ng-template>

<ng-template #phoneNumberBtn>
	<app-kamona-custom-button
		(submitForm)="getLoginType()"
		[isBlock]="true"
		[isDisabled]="usernameType === UserNameType.PHONENUMBER ? phoneNumberForm?.invalid : usernameForm?.invalid"
		[isSubmitting]="loadingLoginType"
		[type]="'primary'"
		text="Next">
	</app-kamona-custom-button>
</ng-template>

<ng-template #pwdBtn>
	<app-kamona-custom-button
		(submitForm)="handleSignIn()"
		[isDisabled]="passwordType === PasswordType.PASSCODE ? passcode?.length !== 6 : password?.length < 6"
		[isBlock]="true"
		[isSubmitting]="loadingLoginType"
		[type]="'primary'"
		text="Login">
	</app-kamona-custom-button>
</ng-template>

<ng-template #userNameTemplate>
	<div class="flex flex-col gap-[20px] animate__animated animate__slideInRight">
		<app-kamona-input-field [input]="username">
		</app-kamona-input-field>
		<ng-container *ngTemplateOutlet="phoneNumberBtn"></ng-container>
	</div>
</ng-template>

<ng-template #deviceRegistrationTemplate>
	<div class="flex flex-col gap-[24px]">
		<div class="flex justify-center">
			<svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="22.5" cy="22.5" r="22.5" fill="#0361F0"/>
				<path d="M17.9998 25V20.9801L24.0398 20.9821L24.0198 29.0001H26.0395V33H19.9995V25H17.9998Z" fill="white"/>
				<path d="M19.9995 17.0381V13H24.0398V17.0381H19.9995Z" fill="white"/>
			</svg>
		</div>
		<div class="flex flex-col gap-[4px] text-center">
			<div class="leading-[24.48px] text-[18px] font-semibold text-black">
				Register New Device
			</div>
			<div class="leading-[16.8px] text-[12px] font-medium text-black/70">
				Your login was Successful but you need to register this device.
			</div>
		</div>
		<div class="flex gap-[16px]">
			<div (click)="closeDeviceRegistrationModal()" class="bg-[#E6EEFD] basis-1/2 flex justify-center cursor-pointer grow rounded-[8px] items-center py-[6px] h-[48px] px-[16px]">
				<div class="text-[#0361F0] leading-[17.36px] text-[16px] font-medium">Dismiss</div>
			</div>
			<div (click)="registerDevice()" class="bg-[#0361F0] basis-1/2 flex grow cursor-pointer rounded-[8px] justify-center items-center py-[6px] h-[48px] px-[16px]">
				<div class="text-white leading-[17.36px] text-[16px] font-medium">Register Device</div>
			</div>
		</div>
	</div>
</ng-template>
